export const profileConstants = {
    REQUEST_PROFILE: 'REQUEST_PROFILE',
    RECIEVE_PROFILE: 'RECIEVE_PROFILE',
    ERROR_PROFILE: 'ERROR_CPROFILE',
};
